import styled from 'styled-components';
import {useState, useEffect} from 'react'

import { useGamepadCom, useGamepadSession } from "../../../../unboared-com";
import { PLAYER_COLOR, useWindowOrientation, ChangeOrientation } from '../../../../react-unboared';
import CarteVerso from '../../assets/img/cards/Cartes_Verso.png';
import ThrowButton from '../../assets/img/cards/Throw_Button.png';
// import DiscIcon from '../../assets/img/cards/Throw_Icon.svg';
import { DiscSVG } from '../../components/SVGDiscIcon';
import { getUserPosition } from '../../../../Tools';

const StyledGamepad = styled.div`
position: absolute;
width: 80vw;
height: 80vh;
top: 10vh;
left: 10vw;
right: 10vw;
display: flex;

#throw_card {
    margin: 5%;
    width: 50%;
    height: 100%;
    background: url(${CarteVerso});
    background-size: 100%;
    background-repeat: no-repeat;
}

#throw_disc {
    position :relative;
    margin: 5%;
    width: 50%;
    height: 100%;
    background: url(${ThrowButton});
    background-size: 100%;
    background-repeat: no-repeat;
    color:${({ color }) => color};
    svg {
        position:absolute;
        left:10%;
        width:80%;
    }

}
.centerMsg {
    position:absolute;
    top: 50%;
    left: 50%;
    transform:translate(-50%,-50%)
}
`

const Gamepad = () => {
    const { emitAction } = useGamepadCom();
    const id = useGamepadSession(state => state.id);
    const [isPlaying, setIsPlaying] = useState(false);
    const statusPlayers = useGamepadSession(state => state.statusPlayers);
    const windowOrientation = useWindowOrientation();

    useEffect(() => {
        setIsPlaying(getUserPosition(statusPlayers.players, id) < 4)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!isPlaying) {
        return <StyledGamepad color={PLAYER_COLOR[id]}><h1 className='centerMsg' style={{color:'black'}}>It is a 4 player game !</h1></StyledGamepad>
    }


    if (windowOrientation === 'PORTRAIT') {
        return <ChangeOrientation to='LANDSCAPE' />
    }


    return (
        <StyledGamepad color={PLAYER_COLOR[id]}>
            <div id='throw_card' onClick={() => { emitAction('throw_card') }}>

            </div>
            <div id='throw_disc' onClick={() => { emitAction('throw_disc') }}>
                <DiscSVG />
            </div>
        </StyledGamepad>
    );
}

export default Gamepad;

        // let controller = document.getElementById('controller')

        // let throw_card = document.createElement('div')
        // throw_card.setAttribute('id', 'throw_card')
        // throw_card.addEventListener("click", () => { sendAction('throw_card', { player: '1' }) })


        // let throw_disc = document.createElement('div')
        // throw_disc.setAttribute('id', 'throw_disc')
        // throw_disc.addEventListener("click", () => { sendAction('throw_disc', { player: '1' }) })
        // const throwDiscHTML = "<div id='throw_disc_icon'><svg version='1.1' fill='" + COLOR_PLAYER[this.player_id] + "' id='Calque_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox = '0 0 400 400' style = 'enable-background:new 0 0 400 400;' xml: space = 'preserve'> <path transform='translate(0,-20)' d='M204.52,130.33c5.02,4.47,9.91,8.82,14.8,13.17c2.35,2.09,4.71,4.16,7.04,6.27c1.94,1.75,2.22,3.6,0.84,5.16   c-1.32,1.51-3.38,1.48-5.25-0.17c-7.57-6.7-15.11-13.43-22.68-20.14c-4.35-3.85-9.36-5.76-15.22-4.96   c-3.32,0.45-5.83,2.51-8.66,4.41c1.22,0.92,2.35,1.78,3.48,2.63c9.99,7.5,19.98,14.99,29.97,22.49c0.54,0.41,1.12,0.81,1.57,1.31   c1.22,1.35,1.28,2.87,0.19,4.28c-1.03,1.33-2.46,1.7-4.02,0.93c-0.6-0.3-1.14-0.75-1.68-1.15c-11.25-8.43-22.62-16.71-33.7-25.36   c-5.48-4.28-11.24-3.39-15.59-0.82c-4.52,2.67-4.53,2.66-0.24,5.6c12.2,8.39,24.4,16.77,36.6,25.16c0.56,0.39,1.15,0.75,1.64,1.22   c1.3,1.25,1.52,2.7,0.56,4.25c-0.9,1.46-2.69,1.9-4.31,1.08c-0.6-0.3-1.16-0.71-1.72-1.09c-14.62-10.05-29.23-20.1-43.85-30.14   c-4.27-2.93-7.26-2.68-10.89,0.94c-6.48,6.47-12.9,12.99-19.44,19.4c-4.08,4.01-6.07,8.75-6.01,14.47   c0.08,7.65,0.01,15.3,0.02,22.96c0.01,3.75,2.84,5.89,6.44,4.8c2.92-0.89,4.89-2.78,5.84-5.77c1.54-4.84,1.2-9.87,1.63-14.81   c0.3-3.48,0.79-6.91,2.35-10.09c3.62-7.36,10.48-9.91,18.14-6.97c5.66,2.17,10.28,5.93,14.87,9.65   c10.06,8.15,17.94,18.11,23.39,29.89c2.76,5.97,3.91,12.19,1.66,18.66c-2.6,7.47-8.21,11.75-15.42,14.05   c-10.11,3.22-19.37,1.47-27.62-5.34c-3.99-3.29-7.84-6.82-12.92-8.46c-5.31-1.72-10.68-2.15-16.1-0.61   c-2.17,0.62-2.33,1.05-1.13,2.8c7.15,10.36,14.9,20.26,24.02,28.96c7.36,7.03,16.42,10.41,26.58,10.49   c14.07,0.11,28.15,0.01,42.22,0.02c11.86,0.01,23.25-2.73,34.58-5.89c6.82-1.91,13.7-3.63,20.52-5.55   c5.87-1.66,11.73-1.47,17.63-0.31c3.01,0.59,6.05,1.03,9.08,1.54c0.34,0.06,0.67,0.11,1.01,0.18c2.33,0.54,3.54,2.08,3.15,4   c-0.39,1.92-2.13,2.91-4.43,2.54c-4.78-0.77-9.57-1.51-14.34-2.32c-3.38-0.58-6.65-0.07-9.92,0.76c-12.54,3.19-24.93,7.02-37.6,9.69   c-5.95,1.26-11.99,1.95-18.09,1.95c-15.17,0.01-30.34,0.22-45.5-0.07c-12.44-0.24-22.99-5.32-31.63-14.22   c-8.29-8.54-15.7-17.83-22.57-27.54c-4.08-5.77-1.82-12.11,5.05-13.71c10.82-2.51,20.69-0.38,29.52,6.43   c2.81,2.17,5.39,4.6,8.41,6.51c7.54,4.76,19.07,3.75,25.52-2.41c4.24-4.05,5.31-9.04,3.87-14.64c-1.78-6.88-5.69-12.65-9.77-18.28   c-5.8-7.99-13.19-14.35-21.32-19.88c-1.75-1.19-3.65-2.12-5.65-2.84c-4.13-1.47-7.4-0.14-9.26,3.84c-1.29,2.77-1.56,5.78-1.74,8.78   c-0.33,5.58-0.33,11.18-2.3,16.55c-2.75,7.52-11.99,11.52-18.95,7.95c-3.58-1.84-5.81-4.78-5.84-8.93   c-0.06-9.15-0.14-18.31,0.07-27.46c0.13-5.35,2.2-10.18,5.92-14.03c7.37-7.61,14.85-15.1,22.43-22.49   c4.08-3.98,9.03-4.83,14.38-2.83c0.89,0.33,1.43,0.25,2.2-0.28c4.03-2.78,7.97-5.79,12.98-6.67c2.71-0.48,5.42-0.68,8.11,0.1   c1.06,0.31,1.89,0.16,2.84-0.49c3.31-2.26,6.5-4.8,10.45-5.91c5.5-1.55,10.82-0.88,15.95,1.49c1.17,0.54,2.11,0.59,3.25,0   c3.63-1.9,7.29-3.71,11.57-3.62c4.4,0.09,8.1,1.31,11.29,4.7c19.57,20.79,39.28,41.46,58.96,62.16c4.03,4.24,9.09,7.18,13.63,10.77   c2.72,2.15,3.38,3.89,1.96,5.74c-1.32,1.72-3.26,1.52-5.92-0.31c-8.55-5.86-15.98-12.93-23.05-20.49   c-16.51-17.67-33.27-35.11-49.93-52.64c-3.24-3.41-7.13-4.2-11.47-2.34C206.21,129.37,205.47,129.83,204.52,130.33z'/> <path transform='translate(0,-20)' d='M266.69,235.91c0.45-12.12,5.5-20.61,15.79-25.78c2.68-1.35,5.11-0.4,5.48,2.04c0.25,1.58-0.27,2.91-1.77,3.55   c-11.4,4.84-14.28,15.88-12.05,27.2c0.17,0.87,0.4,1.73,0.52,2.6c0.25,1.85-0.85,3.49-2.55,3.86c-1.73,0.38-3.37-0.6-3.88-2.48   c-0.47-1.77-0.87-3.58-1.11-5.4C266.85,239.41,266.79,237.3,266.69,235.91z'/> <path transform='translate(0,-20)' d='M261.06,202.7c-0.83,0.04-1.71-0.59-2.5-1.37c-5.26-5.26-10.54-10.51-15.77-15.79c-1.68-1.69-1.78-3.68-0.42-5.07   c1.39-1.41,3.39-1.34,5.07,0.32c5.33,5.29,10.62,10.62,15.93,15.92c1.17,1.17,1.66,2.52,0.96,4.07   C263.79,201.99,262.79,202.66,261.06,202.7z'/> <path transform='translate(0,-20)' d='M234.98,176.02c-1.45-0.01-2.29-0.57-3.03-1.31c-1.94-1.92-3.89-3.83-5.79-5.78c-1.74-1.79-1.86-3.8-0.39-5.22   c1.39-1.35,3.35-1.2,5.06,0.46c2.05,2,4.08,4.02,6.07,6.07c1.03,1.06,1.4,2.34,0.78,3.75C237.12,175.31,236.07,175.96,234.98,176.02   z'/> </svg ></div>"
        // throw_disc.innerHTML = throwDiscHTML

        // controller.appendChild(throw_card)
        // controller.appendChild(throw_disc)

        // let returnUnboared = document.getElementById('return-unboared')

        // let unboaredButton = document.createElement('button')
        // unboaredButton.setAttribute('id', 'menu-button')
        // unboaredButton.setAttribute('class', 'unboared-button')
        //     // unboaredButton.setAttribute('onclick', `sendAction()`)

        // returnUnboared.appendChild(unboaredButton)

        // let returnHome = document.getElementById('return-home')

        // let homeButton = document.createElement('button')
        // homeButton.setAttribute('id', 'menu-button')
        // homeButton.setAttribute('class', 'home-button')
        //     // homeButton.setAttribute('onclick', `location.reload()`)

        // returnHome.appendChild(homeButton)